
// import React, { useState, useEffect } from "react";
// import { Box, Typography } from "@mui/material";
// import { useParams } from "react-router-dom";
// import { RightCard } from "./RightCard";
// // import Navigationbar from "../NavigationBar/Navigationbar";
// // import Navigationbar from "../UserManagement/NavigationBar";
// import axios from "axios";
// import "./VivaExam.css";
// import Config from "../config";

// const Exam_URL = Config.Exam_URL;

// export const VivaCompetitiveExam = () => {
//   const [currentQuestion, setCurrentQuestion] = useState(null);
//   const [questionStatus, setQuestionStatus] = useState({});
//   const [isRecording, setIsRecording] = useState(false);
//   const [stream, setStream] = useState(null);
//   const [audioStream, setAudioStream] = useState(null);
//   const [showPopup, setShowPopup] = useState(false);
//   const [hasStarted, setHasStarted] = useState(false);
//   const { ee_id } = useParams();
  

//   useEffect(() => {
//     if (currentQuestion === null) setCurrentQuestion(0);
//   }, [currentQuestion]);
//   console.log("Received ee_id:", ee_id);

 

//   return (
//     <div className="exam-container">
//       {/* <Box sx={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1200 }}>
//         <Typography><Navigationbar /></Typography>
//       </Box> */}

//         <section className="exam-section" style={{ paddingTop: "120px" }}>
//           <RightCard
//             ee_id={ee_id}
//             currentQuestion={currentQuestion}
//             setCurrentQuestion={setCurrentQuestion}
//             questionStatus={questionStatus}
//             setQuestionStatus={setQuestionStatus}
//             isRecording={isRecording}
//             setIsRecording={setIsRecording}
//             stream={stream}
//             setStream={setStream}
//             audioStream={audioStream}
//             setAudioStream={setAudioStream}
//             showPopup={showPopup}
//             setShowPopup={setShowPopup}
//           />
//         </section>
//     </div>
//   );
// };


import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { RightCard } from "./RightCard";
// import Navigationbar from "../NavigationBar/Navigationbar";
// import Navigationbar from "../UserManagement/NavigationBar";
import axios from "axios";
import "./VivaExam.css";
import Config from "../config";
import React, { useState, useEffect, useRef } from "react";

const Exam_URL = Config.Exam_URL;

export const VivaCompetitiveExam = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [questionStatus, setQuestionStatus] = useState({});
  const [isRecording, setIsRecording] = useState(false);
  const [stream, setStream] = useState(null);
  const [audioStream, setAudioStream] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);

  // const { ee_id } = useParams();

  // console.log("Received ee_id:", ee_id);


  const { ee_id } = useParams();

// Use ref to log only once
const hasLoggedRef = useRef(false);
useEffect(() => {
  if (ee_id && !hasLoggedRef.current) {
    console.log("Received ee_id:", ee_id);
    hasLoggedRef.current = true;
  }
}, [ee_id]);

  return (
    <div className="exam-container">
      {/* 
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1200,
        }}
      >
        <Typography>
          <Navigationbar />
        </Typography>
      </Box> 
      */}

      <section className="exam-section" style={{ paddingTop: "120px" }}>
        <RightCard
          ee_id={ee_id}
          currentQuestion={currentQuestion}
          setCurrentQuestion={setCurrentQuestion}
          questionStatus={questionStatus}
          setQuestionStatus={setQuestionStatus}
          isRecording={isRecording}
          setIsRecording={setIsRecording}
          stream={stream}
          setStream={setStream}
          audioStream={audioStream}
          setAudioStream={setAudioStream}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
        />
      </section>
    </div>
  );
};